export const DeviceErrorMessages: Record<string, string> = {
    OVER_CURRENT_ERROR: "Over current error",
    HV_OVER_ERROR: "HV over voltage error",
    HV_UNDER_ERROR: "HV under voltage error",
    RIGHT_BRIDGE_ERROR: "Right bridge short error",
    LEFT_BRIDGE_ERROR: "Left bridge short error",
    CHECKSUM_ERROR: "Mem checksum error",
    WATCHDOG_ERROR: "Watchdog error (start recover after reboot)",
    CHARGING_ERROR: "Charging timeout error",
    COMMUNICATION_ERROR: "BLE error",
};
